// Japanese translations - using English as fallback for now
export default {
  // Common
  app: {
    name: 'Coloursense',
    tagline: 'あなたの完璧な色を発見',
  },
  common: {
    back: '戻る',
    cancel: 'キャンセル',
    save: '保存',
    share: '共有',
    create: '作成',
    delete: '削除',
    edit: '編集',
    loading: '読み込み中...',
    error: 'エラーが発生しました',
    success: '成功！',
    tryAgain: '再試行',
    reset: 'リセット',
  },

  // Premium Features
  premium: {
    title: 'プレミアム機能をアンロック',
    subtitle:
      'Coloursenseプレミアムにアップグレードして、すべての機能に完全にアクセス',
    smartWardrobe: 'スマートワードローブ',
    wardrobeDesc: '服にタグを付けて、あなたのカラーパレットに合うものを発見',
    wearToday: '今日の着こなし',
    wearTodayDesc: '天気とあなたの色に基づいたAI駆動の服装提案を取得',
    unlimited: '無制限の分析',
    unlimitedDesc: '無制限のカラープロファイルを作成し、分析履歴を保存',
    noAds: '広告なし',
    noAdsDesc: 'アプリ全体で広告のない体験を楽しむ',
    monthly: '月額',
    yearly: '年額',
    save: '30%節約',
    perMonth: '月あたり',
    perYear: '年あたり',
    upgradeButton: 'プレミアムにアップグレード',
    processing: '処理中...',
    restore: '購入を復元',
  },

  // Subscription Context
  subscription: {
    freePlan: '無料プラン',
    premiumPlan: 'プレミアムプラン',
    upgradeSuccess: 'プレミアムへのアップグレードに成功しました！',
    upgradeError: 'プレミアムへのアップグレードに失敗しました',
    restoreSuccess: '購入の復元に成功しました！',
    restoreError: '購入の復元に失敗しました',
    premiumRequired: 'プレミアムが必要',
    premiumFeature: 'これはプレミアム機能です',
    upgradeToAccess:
      'この機能にアクセスするにはプレミアムにアップグレードしてください',
    goToPremium: 'プレミアムへ',
    continueFree: '無料で続ける',
  },
};
